import { LocationSelectorFallback } from '@/components/form/location-selector/fallback'
import { PrivateGitSelectorFallback } from '@/components/form/private-git-selector/fallback'
import { ProcessResourceFallback } from '@/components/form/process-resource-selector/fallback'
import { H3 } from '@/components/sv/typographies'
import { Card, CardContent } from '@/components/ui/card'
import { Separator } from '@/components/ui/separator'
import { Skeleton } from '@/components/ui/skeleton'
import { AutoDeployFallback } from '@/routes/apps/create-app/form/sections/auto-deploy/fallback'
import { NameFallback } from '@/routes/apps/create-app/form/sections/name/fallback'
import { OverviewFallback } from '@/routes/apps/create-app/form/sections/overview/fallback'
import { PaymentMethodFallback } from '@/routes/apps/create-app/form/sections/payment-method/fallback'

export const CreateAppFallback = () => {
  return (
    <div className="grid gap-4 grid-cols-1 lg:grid-cols-[2fr_1fr]">
      <Card>
        <CardContent>
          <H3 className="mb-6">Application details</H3>
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              <Skeleton className="h-22 w-full" />
              <Skeleton className="h-22 w-full" />
              <Skeleton className="h-22 w-full" />
            </div>
            <PrivateGitSelectorFallback />
            <AutoDeployFallback />
            <Separator />
            <NameFallback />
            <LocationSelectorFallback />
            <ProcessResourceFallback />
            <Skeleton className="h-9 w-43" />
          </div>
        </CardContent>
      </Card>
      <div className="flex flex-col gap-4">
        <Card className="hidden lg:block">
          <CardContent>
            <div className="flex flex-col gap-4">
              <H3>Overview</H3>
              <div className="flex flex-col gap-6">
                <OverviewFallback />
                <div className="space-y-1">
                  <Skeleton className="h-2 w-full" />
                  <Skeleton className="h-2 w-full" />
                  <Skeleton className="h-2 w-full" />
                  <Skeleton className="h-2 w-full" />
                  <Skeleton className="h-2 w-[30%]" />
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
        <Card className="hidden lg:block">
          <CardContent>
            <div className="flex flex-col gap-4">
              <H3>Payment method</H3>
              <div className="flex flex-col gap-6">
                <PaymentMethodFallback />
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
